// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__zWOKs","cell":"ColumnAccessor_cell__2qXOG","firstCellAccent":"ColumnAccessor_firstCellAccent__2Xppu"};